import React from 'react'

const LockIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M2.625 5.0273V4C2.625 2.13604 4.13604 0.625 6 0.625C7.86396 0.625 9.375 2.13604 9.375 4V5.0273C9.93238 5.06893 10.2953 5.17402 10.5607 5.43934C11 5.87868 11 6.58579 11 8C11 9.41421 11 10.1213 10.5607 10.5607C10.1213 11 9.41421 11 8 11H4C2.58579 11 1.87868 11 1.43934 10.5607C1 10.1213 1 9.41421 1 8C1 6.58579 1 5.87868 1.43934 5.43934C1.70466 5.17402 2.06762 5.06893 2.625 5.0273ZM3.375 4C3.375 2.55025 4.55025 1.375 6 1.375C7.44975 1.375 8.625 2.55025 8.625 4V5.00179C8.43349 5 8.22576 5 8 5H4C3.77424 5 3.56651 5 3.375 5.00179V4Z" fill="#404040" />
        </svg>
    )
}

export default LockIcon